import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import PrivateRoute from './components/PrivateRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import Login from './pages/Login';
import SecurityLogin from './pages/SecurityLogin';
import Dashboard from './pages/Dashboard';
import LiveChat from './pages/LiveChat';
import Analytics from './pages/Analytics';
import ServiceRequests from './pages/ServiceRequests';
import WhiteLabel from './pages/WhiteLabel';
import Reminders from './pages/Reminders';
import Guests from './pages/Guests';
import Rooms from './pages/Rooms';
import AIChat from './pages/AIChat';
import CriticalFixes from './pages/CriticalFixes';
import SlotManagement from './pages/SlotManagement';
import Bookings from './pages/Bookings';
import Users from './pages/Users';
import FeedbackDashboard from './pages/FeedbackDashboard';
import Settings from './pages/Settings';
import DepartmentStaff from './pages/DepartmentStaff';
import Attendance from './pages/Attendance';
import GuestMemory from './pages/GuestMemory';
import GuestRegistration from './pages/GuestRegistration';
import AgentPilot from './pages/AgentPilot';
import QrRooms from './pages/QrRooms';
import LoginActivity from './pages/LoginActivity';

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/security/login" element={<SecurityLogin />} />
            <Route path="/guest-registration" element={<GuestRegistration />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <LiveChat />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <PrivateRoute>
                  <Analytics />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics/operations"
              element={<Navigate to="/analytics?tab=staff" replace />}
            />
            <Route
              path="/requests"
              element={
                <PrivateRoute>
                  <ServiceRequests />
                </PrivateRoute>
              }
            />
            <Route
              path="/whitelabel"
              element={
                <PrivateRoute>
                  <WhiteLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/critical-fixes"
              element={
                <PrivateRoute>
                  <CriticalFixes />
                </PrivateRoute>
              }
            />
            <Route
              path="/reminders"
              element={
                <PrivateRoute>
                  <Reminders />
                </PrivateRoute>
              }
            />
            <Route
              path="/guests"
              element={
                <PrivateRoute>
                  <Guests />
                </PrivateRoute>
              }
            />
            <Route
              path="/rooms"
              element={
                <PrivateRoute>
                  <Rooms />
                </PrivateRoute>
              }
            />
            <Route
              path="/ai-chat"
              element={
                <PrivateRoute>
                  <AIChat />
                </PrivateRoute>
              }
            />
            <Route
              path="/agent-pilot"
              element={
                <PrivateRoute>
                  <AgentPilot />
                </PrivateRoute>
              }
            />
            <Route
              path="/slots"
              element={
                <PrivateRoute>
                  <SlotManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/bookings"
              element={
                <PrivateRoute>
                  <Bookings />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <RoleProtectedRoute
                  allowedRoles={['admin', 'manager']}
                  requiredTab="/security/login-history"
                  redirectTo="/login?mode=security"
                >
                  <Users />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/security/login-history"
              element={
                <RoleProtectedRoute
                  allowedRoles={['admin', 'manager']}
                  requiredTab="/security/login-history"
                  redirectTo="/login?mode=security"
                >
                  <LoginActivity />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/department-staff"
              element={
                <PrivateRoute>
                  <DepartmentStaff />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr"
              element={
                <PrivateRoute>
                  <QrRooms />
                </PrivateRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <FeedbackDashboard />
                </PrivateRoute>
              }
            />
{/* 
            <Route
              path="/attendance"
              element={
                <PrivateRoute>
                  <Attendance />
                </PrivateRoute>
              }
            />
            <Route
              path="/guest-memory"
              element={
                <PrivateRoute>
                  <GuestMemory />
                </PrivateRoute>
              }
            />
            */}
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings/dispatch-routing"
              element={<Navigate to="/department-staff?section=routing" replace />}
            />
            {/* 
            <Route
              path="/settings/attendance"
              element={<Navigate to="/attendance" replace />}
            />
            */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            {/* Redirect root to dashboard - Dashboard component handles role-based display */}
          </Routes>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;

